import { render, staticRenderFns } from "./step-confirmar.vue?vue&type=template&id=77a8ed05&"
import script from "./step-confirmar.vue?vue&type=script&lang=js&"
export * from "./step-confirmar.vue?vue&type=script&lang=js&"
import style0 from "./step-confirmar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports